// audio.js
import { Utils } from "./utils.js";

export const Audio = {
    _sounds: {},
    _playedOnce: new Set(),
    _muted: false,

    /**
     * Rejestruje dźwięk i preloaduje go
     * @param {string} name
     * @param {string} path
     */
    register(name, path) {
        this._sounds[name] = Utils.preloadAudio(path);
    },

    /**
     * Odtwarza dźwięk (zawsze od początku)
     * @param {string} name
     */
    play(name) {
        if (this._muted) return;

        const audio = this._sounds[name];
        if (!audio) return;

        audio.currentTime = 0;
        audio.play().catch(() => { });
    },

    /**
     * Odtwarza dźwięk TYLKO RAZ dla danego klucza
     * Idealne do SLA / alarmów
     * @param {string} name
     * @param {string|number} key
     */
    playOnce(name, key) {
        if (this._muted) return;

        const uniqueKey = `${name}:${key}`;
        if (this._playedOnce.has(uniqueKey)) return;

        this._playedOnce.add(uniqueKey);
        this.play(name);
    },

    /**
     * Resetuje pamięć "playOnce"
     * (np. po przeładowaniu dashboardu)
     */
    resetOnce() {
        this._playedOnce.clear();
    },

    /**
     * Wyciszenie globalne
     */
    mute() {
        this._muted = true;
    },

    /**
     * Włączenie dźwięku
     */
    unmute() {
        this._muted = false;
    },

    /**
     * Sprawdzenie stanu mute
     */
    isMuted() {
        return this._muted;
    }
};
